<template>
  <div>
     <headNav></headNav>
     <div  style="height: 50px;"></div>
    <div>
      <img src="../assets/xwdt.png" class="img-responsive" />
    </div>



    <div class="container" style="margin-top: 24px;">
      <div class="row">
        <div class="col-md-3 visible-lg-block visible-md-block">

          <div
            style="padding: 12px 20px;background-color: rgba(0,0,0,.03);border: 1px solid rgba(0,0,0,.125); border-bottom: 0px;border-radius: 5px;">
            <img src="../assets/publicHead.png" class="img-responsive" />
          </div>
         <div style="width: 100%;" class="btn-group-vertical " role="group">
           <router-link to="/dszzc"><button type="button" class="btn btn-default btn-block">董事长致辞</button></router-link>
           <router-link to="/gsjj"><button type="button" class="btn btn-default btn-block">公司简介</button></router-link>
           <router-link to="/wdjf"><button type="button" class="btn btn-default btn-block">威盾技防</button></router-link>
           <router-link to="/fwfw"> <button type="button" class="btn btn-default btn-block">服务范围</button></router-link>
           <router-link to="/xmzs"><button type="button" class="btn btn-default btn-block">项目展示</button></router-link>
           <router-link to="/wdtb"><button type="button" class="btn btn-default btn-block">威盾特保</button></router-link>
           <router-link to="/xwdt"><button type="button" class="btn btn-default btn-block">新闻动态</button></router-link>
           <button type="button" class="btn btn-primary btn-block">报纸专栏</button>
           <router-link to="/hyxw"><button type="button" class="btn btn-default btn-block">行业新闻</button></router-link>
         </div>
          <div
            style="padding: 12px 20px;background-color: rgba(0,0,0,.03);border: 1px solid rgba(0,0,0,.125); border-bottom: 0px;border-radius: 5px;">
            <img src="../assets/hezuo.png" class="img-responsive" />
          </div>

        </div>
        <div class="col-md-9 text-left">
          <div>
          <h2 style="font-weight: bold;margin-top: 0px;">报纸专栏</h2>
           <div v-for="(item,index) in result" :key="index">
             <router-link  :to="{path:'/xwxq',query:{id:item.id}}">
            <div class="row">
              <span class="col-md-9 col-xs-12 span16">{{item.title}}</span>
              <span class="col-md-2 col-xs-12 span14">{{item.create_time}}</span>
            </div>
            </router-link>
           </div>
          </div>
            <div class="text-center">
                <!--分页器-->
              <Pagenation   type="2" @getnews="getnews"></Pagenation>
            </div>


        </div>
      </div>
    </div>
    <Base></Base>
  </div>

</template>

<script>
  export default {
    data() {
      return {
          result:[],
      }
    },
    mounted:function(){
    },
    methods: {
      getnews(val){
        console.log(val)
        this.result=val;
      }


    }




  }
</script>

<style>
  .btn-block {
    border-radius: 0px;
    height: 49px;
  }
  .row{
    margin-left: 0px;
    margin-right: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/bzzl.vue